module.exports = __webpack_public_path__ + "static/DSC_9257-5ce3b118951a5c6279ab55d057d2f113.jpg";